import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const ChatRequest = async(params) => {
  try {
    const cookies = new Cookies();
    const token = cookies.get('token');
        
    const res = await AxiosInstance.get('/chat?id=' + params.id + '&comment=' + params.comment, {
      headers: {
        'Authorization': `Bearer ${token}`
        }
    });

    return res;
  } catch (error) {
    console.error('error in request:', error);
    return null;
  }     
};

export default ChatRequest;
